import styled from '@emotion/styled';

export const EmptyFieldContainer = styled.div(props => ({
	width: '100%',
	height: '400px',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	color: props.theme.mode === 'light' ? '#CCD0DA' : '#828282',
	div: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		flexDirection: 'column',
		gap: '10px',
	},

	p: {
		marginTop: '10px',
	},

	img: {
		width: '120px',
	},

	'@media(max-width:600px)': {
		height: 'auto',
		padding: '32px 0',
		img: {
			width: '80px',
		},

		div: {
			gap: '5px',
		},
	},
}));
